import { Component, OnInit, ChangeDetectorRef, ViewChild, OnDestroy, ChangeDetectionStrategy, ViewEncapsulation, ElementRef, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import icClose from '@iconify/icons-ic/twotone-close';
import twotoneDeleteForever from '@iconify/icons-ic/twotone-delete-forever';


import { Honeycomb } from 'src/app/services/honeycomb-api/honeycomb-api';
import { Store, select } from '@ngrx/store';
import { combineLatest, lastValueFrom, Observable, of, pipe, Subscription } from 'rxjs';
import { AppState } from 'src/app/app.states';
import { 
        //loadMyTasksSetPageIndexAction, 
        //loadTasksAction, 
        taskFilterSetDefaultAction } from 'src/app/api/tasks/my-tasks/my-tasks.actions';
import { debounceTime, tap, distinctUntilChanged, map, filter, take, withLatestFrom } from 'rxjs/operators';

import { PopoverRef } from 'src/@vex/components/popover/popover-ref';
import { TaskListFilterModel } from './task-list-filter.model';
import endOfWeek from 'date-fns/endOfWeek';
import { startOfWeek, add, endOfMonth, startOfMonth, endOfDay } from 'date-fns';
import { MatSelectChange } from '@angular/material/select';
import { RoleAttributeTaskerValueModel, DefaultTaskFilter } from 'src/app/api/user/roleAttributeTaskerValue.model';
import { filterEnumToName, filterNameToEnum } from '../task-common';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { enumToStrings, replaceDiacritics } from 'src/app/common/functions';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { TaskAgenda } from 'src/app/api/tasks/my-tasks/my-tasks.state';
import { loadOperationsAction } from 'src/app/api/operations/operations.actions';
import { untilDestroyed } from '@ngneat/until-destroy';
import { TasksService } from 'src/app/services/tasks.service';

@Component({
  selector: 'task-list-filter',
  templateUrl: './task-list-filter.component.html',
  styleUrls: ['./task-list-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class TaskListFilterComponent implements OnInit, OnDestroy {

  priority = Honeycomb.Common.Enums.Priority;
  priorityList = Object.entries(Honeycomb.Common.Enums.Priority).filter(e => !isNaN(e[0]as any)).map(e => ({ id: e[0], name: e[1] }));
  baseStatusList = Object.entries(Honeycomb.Common.Enums.TaskState).filter(e => !isNaN(e[0]as any)).map(e => ({ id: e[0], name: e[1] }));
  taskTypeList = Object.entries(Honeycomb.Common.Enums.TaskType).filter(e => !isNaN(e[0] as any))
                                                                .map(e => ({ id: Number(e[0]), name: e[1] }))
                                                                .filter(e => e.id !== Honeycomb.Common.Enums.TaskType.unknown);
  readList = Object.entries(Honeycomb.Common.Enums.TaskRead).filter(e => !isNaN(e[0]as any)).map(e => ({ id: Number(e[0]), name: e[1] }));

  model: TaskListFilterModel;
  storedModel: Honeycomb.Tenant.Tasker.IService.TaskListFilter;
  dashboard: RoleAttributeTaskerValueModel;
  locationDataReady = false;
  subscriptions: Array<Subscription> = [];
  allLocations: Array<{ locationID: string, name: string }> = [];
  filteredLocations: Array<{ locationID: string, name: string }> = [];
  filterTypes: Array<Honeycomb.Common.Enums.TaskType> = [];
  disableDate = false;

  statusesAll$: Observable<Array<Honeycomb.Tenant.Tasker.IService.Model.TaskStatus>>;

  statuses$: Observable<Array<Honeycomb.Tenant.Tasker.IService.Model.TaskStatus>> = of([]);
  // IDK why statuses$ didn't worked on second window pop-up. Statuses is workroud, that works
  statuses: Array<Honeycomb.Tenant.Tasker.IService.Model.TaskStatus> = [];

  @ViewChild('assigneeInput') assigneeInput: ElementRef<HTMLInputElement>;

  selectedJobID: number;

  taskFilters$: Observable<Array<DefaultTaskFilter>>;
  dashboardFilters$: Observable<Array<DefaultTaskFilter>>;
  assignees$: Observable<Array<Honeycomb.Tenant.Contact.IService.SimpleUserJob>>;
  operations$: Observable<Array<Honeycomb.Tenant.Tasker.IService.Model.Operation>>;
  operations: Array<Honeycomb.Tenant.Tasker.IService.Model.Operation>;

  operationsInitialized = false;

  taskAgenda = TaskAgenda;

  filterForm: FormGroup = new FormGroup(
    {
      mainFilter: new FormControl(Honeycomb.Common.Enums.TaskMainFilter.all, Validators.required),
      priorities: new FormControl(''),
      taskRead: new FormControl(0),
      // taskStates: new FormControl(''),
      taskStatusIDs: new FormControl([]),
      taskTypes: new FormControl([]),
      operations: new FormControl([]),
      locationInput: new FormControl(''),
      locationIDs: new FormControl([]),
      dateFrom: new FormControl(''),
      dateTo: new FormControl(''),
      assigneeControl: new FormControl(''),
    }
  );

  @ViewChild('locationInput') locationInput: ElementRef<HTMLInputElement>;

  icClose = icClose;
  twotoneDeleteForever = twotoneDeleteForever;

  constructor(private cd: ChangeDetectorRef,
              private popoverRef: PopoverRef<TaskListFilterComponent>,
              @Inject('ContactJobController') private jobController: Honeycomb.Tenant.Contact.IService.Controller.JobController,
              @Inject('ContactController') private contactController: Honeycomb.Tenant.Contact.IService.Controller.ContactController,
              // tslint:disable-next-line: max-line-length
              @Inject('TaskerLocationController') private taskerLocationController: Honeycomb.Tenant.Tasker.IService.Controller.LocationController,
              // tslint:disable-next-line: max-line-length
              @Inject('TaskStatusController') private taskStatusController: Honeycomb.Tenant.Tasker.IService.Controller.TaskStatusController,
              private store: Store<AppState>,
              private snack: MatSnackBar,
              private tasksService: TasksService,
              private trans: TranslateService) {
    this.model = popoverRef.data as any;

    this.disableDate = !!this.model.disableDate;

    // Load operations if not loaded
    const opsSubsr = store.select(o => o.operations.results).subscribe(o => { if(!o) {
      store.dispatch(loadOperationsAction());
    }});
    this.subscriptions.push(opsSubsr);

    this.filterTypes = this.model.agenda === TaskAgenda.Repairs ?
                            [Honeycomb.Common.Enums.TaskType.repairRequest] :
                            [Honeycomb.Common.Enums.TaskType.freeTask,
                             Honeycomb.Common.Enums.TaskType.repairRequest,
                             Honeycomb.Common.Enums.TaskType.templated,
                             Honeycomb.Common.Enums.TaskType.unknown];

    const s1 = this.filterForm.get('assigneeControl')
        .valueChanges.pipe(
          debounceTime(300),
          distinctUntilChanged(),
          filter(value => value !== null && typeof(value) === 'string'),
          map(async (value: any) => {
            if (value.trim().length < 3) {
                this.assignees$ = of([]);
                this.showSnack('tasker.common.min-3-chars');
            } else {
                const found = await this.jobController.JobUsers(1, true, value).toPromise();
                this.assignees$ = of(found);
                if (!found.length) { this.showSnack('tasker.common.no-matching-record'); }
            }
            this.cd.detectChanges();
          })
        )
        .subscribe(_ => null);

    this.subscriptions.push(s1);

    this.taskFilters$ = store.pipe(select(x => x.myTasks.taskFilters), filter(tf => !!tf));

    store.pipe(select(u => u.user), filter(u => !!u)).subscribe(
      u => this.selectedJobID = u.selectedJobID
    );

    this.dashboardFilters$ = store.pipe(select(x => x.user.dashboard),
      filter(f => !!f),
      tap(d => { this.dashboard = d; }),
      map(tf => tf.taskFilters),
      tap(df => {
        if (!this.filterForm.get('mainFilter').value) {
          const dashDef = df.find(d => !!d.default);
          // set default if not set
          // TCh - difference between /my-tasks/main default filter and dashboard filter
          // Use just as datasource
          // this.filterForm.get('mainFilter').setValue(dashDef.name);
        }
      })
      );

      const filterSub = this.taskFilters$.subscribe(tf => {
      const defFilter = tf.find(f => !!f.default);
      if (!!defFilter) {
        this.filterForm.get('mainFilter').setValue(defFilter.name);
        return;
      } else {
        this.filterForm.get('mainFilter').setValue('all');
      }
    });

    this.subscriptions.push(filterSub);

    this.operations$ = combineLatest([store.select(s => s.myTasks.filter), store.select(s => s.operations.results)])
    .pipe(
      filter((o, i) => !!o[0] && !!o[1]),
      map(o => {
        return {
          filter: o[0],
          operations: o[1]
        };
      }),
      tap(o => {
        if (!this.operationsInitialized) {
          let preselectedOperations = [];
          if (!o.filter.operations) {      
            // HACK: Only repair task types are not preselected on main filter          
            if (this.model.agenda !== TaskAgenda.Repairs) {            
              preselectedOperations = o.operations.filter(p => p.taskType !== Honeycomb.Common.Enums.TaskType.repairRequest);
            }
            //this.filterForm.get('operations').setValue(preselectedOperations.map(a => a.operationID));
            this.operationsInitialized = true;
          }
        }
      }),
      map(o => {
        const opsForType = o.operations.filter(b => this.filterTypes.indexOf(b.taskType) > -1).sort((a, b) => a.sortIndex - b.sortIndex);
        return opsForType;
      })
    );

    let opSub = this.operations$.subscribe(o => { 
      this.operations = o;
    });
    this.subscriptions.push(opSub);

    this.statusesAll$ = this.taskStatusController.List(null, this.selectedJobID);

    this.statuses$ = combineLatest([this.statusesAll$, this.operations$, this.filterForm.valueChanges])
      .pipe(
        take(1),
        map(([s, o, f]) => {
          var res = s.filter((a, i) => a.operationStatuses.map(oa => f.operations.includes(oa.operationID)).length > 0);
          this.statuses = res;
          this.cd.detectChanges();

          if (!this.filterForm.get('operations').value || this.filterForm.get('operations').value.length === 0) {
            this.filterForm.get('operations')
                .setValue(o.map(a => a.operationID));
          }

          return res;
        } ),
        tap(s => {
          if (!this.filterForm.get('taskStatusIDs').value || this.filterForm.get('taskStatusIDs').value.length === 0) {
            // this.filterForm.get('taskStatusIDs')
            //     .setValue(s.filter(a => !!a.defaultFilter).map(a => a.taskStatusID));
          }
        })
      );

    const statusSubscr = this.statusesAll$.subscribe(_ => null);
    this.subscriptions.push(statusSubscr);

    const statusesSubscr = this.statuses$.subscribe(_ => null);
    this.subscriptions.push(statusesSubscr);

    const opsSubs = this.operations$.subscribe();
    this.subscriptions.push(opsSubs);

    this.storedModel = this.tasksService.getFilterCopy();

    /* set values */

    if (!this.storedModel.mainFilter) {
      this.filterForm.get('mainFilter').setValue(filterEnumToName(Honeycomb.Common.Enums.TaskMainFilter.all));
    } else {
      this.filterForm.get('mainFilter').setValue(filterEnumToName(this.storedModel.mainFilter));
    }

    
    this.filterForm.get('priorities').setValue(this.storedModel.priorities);
    this.filterForm.get('taskTypes').setValue(this.storedModel.taskTypes);
    this.filterForm.get('taskRead').setValue(this.storedModel.taskRead || 0);
    this.filterForm.get('taskStatusIDs').setValue(this.storedModel.taskStatusIDs || []);
    this.filterForm.get('operations').setValue(this.storedModel.operations || this.filterForm.get('operations').value || []);
    if (this.storedModel.locations) {
      this.filterForm.get('locationIDs').setValue(this.storedModel.locations.map(l => l.toString()));
    } else {
      this.filterForm.get('locationIDs').setValue([]);
    }

    this.filterForm.get('locationInput').setValue('');
    this.filterForm.get('dateFrom').setValue(this.storedModel.dateFrom);
    this.filterForm.get('dateTo').setValue(this.storedModel.dateTo);

    /* END - set values */

    const locationSubscr = this.filterForm.get('locationInput').valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged())
      .subscribe(v => {
        this.filteredLocations = this.allLocations
              .filter(al => replaceDiacritics(al.name.toLocaleLowerCase()).indexOf(replaceDiacritics(v.toLocaleLowerCase())) > -1);
        this.cd.detectChanges();
      });
    this.subscriptions.push(locationSubscr);
  }

  async ngOnInit() {
    if (!this.model.filterLocations$) {
      this.model.filterLocations$ = this.taskerLocationController
      .MyLocations({ userTaskRelations: [ ], selectedJobID: this.selectedJobID }).pipe(
        map(Object.entries),
        map(c => c.map(a => ({ locationID: a[0], name: a[1] })))
      );
    }

    if (this.storedModel.taskRelationAdditional && this.storedModel.taskRelationAdditional.length > 0) {
      const assignee = this.storedModel.taskRelationAdditional.find(tr => tr.taskRelation === Honeycomb.Common.Enums.TaskRelation.assignee);
      if (assignee) {
        this.filterForm.get('assigneeControl').setValue({
          user: {
            id: assignee.userID,
          }
        });
        const user = await lastValueFrom(this.contactController.ByUserID(assignee.userID));
        this.assigneeInput.nativeElement.value = user.formatedName;
      }
    }

    this.operations = await lastValueFrom(this.operations$);
    this.allLocations = await lastValueFrom(this.model.filterLocations$);

    this.filteredLocations = [];
    this.locationDataReady = true;
    this.cd.detectChanges();
  }

  cancel() {
    this.popoverRef.close();
  }

  locationDisplayFn(locationID: string) {
    if (!locationID)  { return ''; }
    const loc = this.allLocations.find(al => al.locationID === locationID);
    if (!loc) { return ''; }
    return loc.name;
  }

  addLocation(event: MatAutocompleteSelectedEvent) {
    this.filterForm.controls.locationIDs.value.push(event.option.value);
    this.filterForm.get('locationInput').setValue('');
    this.locationInput.nativeElement.value = '';
  }

  removeLocation(locationID: number) {
    this.filterForm.controls.locationIDs.setValue(this.filterForm.controls.locationIDs.value.filter(f => f !== locationID));
  }

  async handleChange() {
  }

  showSnack(message: string, options?: MatSnackBarConfig) {
    this.snack.open(this.trans.instant(message),
        this.trans.instant('tasker.common.close'),
        Object.assign({ duration: 3000 }, options) as MatSnackBarConfig);
  }

  async toggleAllSelection(items: Observable<any> | Array<any>, formGroup: FormGroup, controlName: string, selector?: string) {
    let fn = (o: Array<any>) => {
      if(formGroup.get(controlName).value.length === o.length) { // selected all
        formGroup.get(controlName).patchValue([], { emitEvent: true });
      } else {
        if (!!selector) {
          formGroup.get(controlName).setValue(o.map(p => p[selector]), { emitEvent: true });  
        } else {
          formGroup.get(controlName).setValue(o, { emitEvent: true });
        }
      }
      this.cd.detectChanges();
    }

    if (items instanceof Array) {
      fn(items);
      return;
    }

    (items as Observable<any>).subscribe(o => {
      fn(o);
    });
  }

  async apply() {

    this.storedModel.mainFilter = filterNameToEnum(this.filterForm.controls.mainFilter.value);
    this.storedModel.userTaskRelations = this.model.userTaskRelation;
    this.storedModel.priorities = this.filterForm.controls.priorities.value;
    this.storedModel.taskRead = this.filterForm.controls.taskRead.value;
    this.storedModel.operations = this.filterForm.controls.operations.value;
    this.storedModel.taskStatusIDs = this.filterForm.controls.taskStatusIDs.value;
    this.storedModel.taskTypes = this.filterForm.controls.taskTypes.value;
    this.storedModel.locations = !!this.filterForm.controls.locationIDs.value ?
                                   this.filterForm.controls.locationIDs.value.map(l => Number(l)) : null;
    const dateFrom = this.toDate(this.filterForm.controls.dateFrom.value);
    this.storedModel.dateFrom = dateFrom ? endOfDay(dateFrom) : null;
    //this.storedModel.dateFrom = this.toDate(this.filterForm.controls.dateFrom.value);
    const dateTo = this.toDate(this.filterForm.controls.dateTo.value);
    this.storedModel.dateTo = dateTo ? endOfDay(dateTo) : null;
    //this.storedModel.dateTo = this.toDate(this.filterForm.controls.dateTo.value);

    if (!!this.storedModel.dateTo) {
      this.storedModel.dateTo.setHours(23, 59, 59, 999);
    }

    if (!!this.filterForm.controls.assigneeControl.value && !!this.filterForm.controls.assigneeControl.value.user) {
      this.storedModel.taskRelationAdditional = [
        {
          taskRelation: Honeycomb.Common.Enums.TaskRelation.assignee,
          userID: this.filterForm.controls.assigneeControl.value.user.id
        }
      ];
    } else {
      this.storedModel.taskRelationAdditional = null;
    }

    this.storedModel.jobID = this.selectedJobID;
    this.tasksService.setPager(this.model.agendaKey, this.tasksService.getFilterCopy().pageIndex || 0, this.tasksService.getFilterCopy().pageSize || 10); // default
    this.tasksService.setFilter(this.storedModel, this.model.agenda, true);

    if (this.popoverRef) {
      this.popoverRef.close();
    }

    await this.tasksService.load(this.model.agendaKey);
  }

  private toDate(val: unknown): Date | null {
    if (!val) return null;

    if (val instanceof Date) return new Date(val.getTime());

    if (typeof val === 'string') {
      const d = new Date(val);
      if (isNaN(d.getTime())) return null;
      return d;
    }

    if (typeof (val as any)?.toDate === 'function') {
      return (val as any).toDate();
    }

    if (typeof (val as any)?.isValid === 'function' && typeof (val as any)?.toDate === 'function') {
      return (val as any).toDate();
    }

    return null;
  }

  setStatus() {
    this.cd.markForCheck();
  }

  addAssignee($event: MatAutocompleteSelectedEvent) {
    const val = $event.option.value;
    this.assigneeInput.nativeElement.value = `${val.user.name}`;
  }

  public hasAssigned() : boolean {
    return this.filterForm.get("assigneeControl").value;
  }

  dateTimeFilteChange(event: MatSelectChange) {
    let dateNow = new Date();

    if ('this_week' === event.value) {
      this.filterForm.controls.dateTo.setValue(endOfWeek(dateNow, {  weekStartsOn: 1 }));
      this.filterForm.controls.dateFrom.setValue(startOfWeek(dateNow, {  weekStartsOn: 1 }));
    }

    if ('next_week' === event.value) {
      dateNow = add(dateNow, { days: 7 });
      this.filterForm.controls.dateTo.setValue(endOfWeek(dateNow, {  weekStartsOn: 1 }));
      this.filterForm.controls.dateFrom.setValue(startOfWeek(dateNow, {  weekStartsOn: 1 }));
    }

    if ('this_month' === event.value) {
      this.filterForm.controls.dateTo.setValue(endOfMonth(dateNow));
      this.filterForm.controls.dateFrom.setValue(startOfMonth(dateNow));
    }

    if ('next_month' === event.value) {
      dateNow = add(dateNow, { months: 1 });
      this.filterForm.controls.dateTo.setValue(endOfMonth(dateNow));
      this.filterForm.controls.dateFrom.setValue(startOfMonth(dateNow));
    }

    if ('custom' === event.value) {
      this.filterForm.controls.dateTo.setValue(null);
      this.filterForm.controls.dateFrom.setValue(null);
    }
  }

  clearAssingneeInput() {
    this.filterForm.get('assigneeControl').setValue(null);
  }

  close() {
    this.popoverRef.close();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => {
      if (s)  {
        s.unsubscribe();
      }
    });
  }
}
